import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';



const PercentageCompleted = styled.div`
  ${(props) => props.proportion && `width: ${props.proportion * 100}%;`}
  height: 100%;
  `;

const LoadingBar = ({
  proportion,
}) => (
  <div className="loading-bar">
    <PercentageCompleted
      className="percentage-complete"
      proportion={proportion}
    />
  </div>
);

LoadingBar.propTypes = {
  proportion: PropTypes.number,
};

export { LoadingBar };
